module.exports = __webpack_public_path__ + "img/buddy_antenna-03.2d505ac2.svg";